export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14377.f4c7f9a1.jpg";